'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ListCarousel = require('./components/ListCarousel.component');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_ListCarousel).default;
  }
});
Object.defineProperty(exports, 'LocalizedListCarousel', {
  enumerable: true,
  get: function get() {
    return _ListCarousel.LocalizedListCarousel;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ../biblio-ui-glue/src/carousel/list-carousel/lib/index.js
// module id = 996
// module chunks = 5